
















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { Action } from 'vuex-class'

@Component<TextInput>({
    model: {
        prop: 'value',
        event: 'input'
    }
})
export default class TextInput extends Vue {
    @Prop(String) public value!: string
    @Prop({ type: String, required: false }) public label!: string
    @Prop(String) public placeholder!: string
    @Prop({ type: String, required: false }) public readonly error!: string
    @Prop({ type: Boolean, required: false, default: false }) public readonly disabled!: boolean
}

